var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimplifaii(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 66.6665H108.333C131.9 66.6665 143.692 66.6665 151.008 73.9915C158.333 81.3082 158.333 93.0998 158.333 116.666C158.333 140.233 158.333 152.025 151.008 159.341C143.692 166.666 131.9 166.666 108.333 166.666H100C100 166.666 95.8334 183.333 66.6667 183.333C66.6667 183.333 75 174.925 75 166.525C62.0583 166.133 54.3333 164.691 48.9917 159.341C41.6667 152.025 41.6667 140.233 41.6667 116.666C41.6667 93.0998 41.6667 81.3082 48.9917 73.9915C56.3083 66.6665 68.1 66.6665 91.6667 66.6665ZM158.333 95.8331H162.5C170.292 95.8331 174.183 95.8331 177.083 97.5081C178.983 98.6052 180.561 100.183 181.658 102.083C183.333 104.983 183.333 108.875 183.333 116.666C183.333 124.458 183.333 128.35 181.658 131.25C180.561 133.15 178.983 134.728 177.083 135.825C174.183 137.5 170.292 137.5 162.5 137.5H158.333M41.6667 95.8331H37.5C29.7083 95.8331 25.8167 95.8331 22.9167 97.5081C21.0166 98.6052 19.4387 100.183 18.3417 102.083C16.6667 104.983 16.6667 108.875 16.6667 116.666C16.6667 124.458 16.6667 128.35 18.3417 131.25C19.4387 133.15 21.0166 134.728 22.9167 135.825C25.8167 137.5 29.7083 137.5 37.5 137.5H41.6667",
    fill: "url(#paint0_linear_31_88)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.333 95.8331H162.5C170.292 95.8331 174.183 95.8331 177.083 97.5081C178.983 98.6052 180.561 100.183 181.658 102.083C183.333 104.983 183.333 108.875 183.333 116.666C183.333 124.458 183.333 128.35 181.658 131.25C180.561 133.15 178.983 134.728 177.083 135.825C174.183 137.5 170.292 137.5 162.5 137.5H158.333M41.6667 95.8331H37.5C29.7083 95.8331 25.8167 95.8331 22.9167 97.5081C21.0166 98.6052 19.4387 100.183 18.3417 102.083C16.6667 104.983 16.6667 108.875 16.6667 116.666C16.6667 124.458 16.6667 128.35 18.3417 131.25C19.4387 133.15 21.0166 134.728 22.9167 135.825C25.8167 137.5 29.7083 137.5 37.5 137.5H41.6667M91.6667 66.6665H108.333C131.9 66.6665 143.692 66.6665 151.008 73.9915C158.333 81.3082 158.333 93.0998 158.333 116.666C158.333 140.233 158.333 152.025 151.008 159.341C143.692 166.666 131.9 166.666 108.333 166.666H100C100 166.666 95.8334 183.333 66.6667 183.333C66.6667 183.333 75 174.925 75 166.525C62.0583 166.133 54.3333 164.691 48.9917 159.341C41.6667 152.025 41.6667 140.233 41.6667 116.666C41.6667 93.0998 41.6667 81.3082 48.9917 73.9915C56.3083 66.6665 68.1 66.6665 91.6667 66.6665Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.5 29.1665C112.5 32.4817 111.183 35.6611 108.839 38.0053C106.495 40.3495 103.315 41.6665 100 41.6665C96.6848 41.6665 93.5054 40.3495 91.1612 38.0053C88.817 35.6611 87.5 32.4817 87.5 29.1665C87.5 25.8513 88.817 22.6719 91.1612 20.3277C93.5054 17.9835 96.6848 16.6665 100 16.6665C103.315 16.6665 106.495 17.9835 108.839 20.3277C111.183 22.6719 112.5 25.8513 112.5 29.1665Z",
    fill: "url(#paint1_linear_31_88)",
    stroke: "white",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 41.6665V66.6665ZM74.9999 99.9998V108.333ZM125 99.9998V108.333Z",
    fill: "url(#paint2_linear_31_88)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9999 41.6665V66.6665M74.9999 99.9998V108.333M125 99.9998V108.333",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3332 137.5C83.3332 137.5 88.8915 141.667 99.9998 141.667C111.108 141.667 116.667 137.5 116.667 137.5",
    fill: "url(#paint3_linear_31_88)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3332 137.5C83.3332 137.5 88.8915 141.667 99.9998 141.667C111.108 141.667 116.667 137.5 116.667 137.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_88",
    x1: 100,
    y1: 66.6665,
    x2: 100,
    y2: 183.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D220A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_88",
    x1: 100,
    y1: 16.6665,
    x2: 100,
    y2: 41.6665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D220A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_88",
    x1: 99.9999,
    y1: 41.6665,
    x2: 99.9999,
    y2: 108.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D220A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_88",
    x1: 99.9998,
    y1: 137.5,
    x2: 99.9998,
    y2: 141.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D220A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5DC9F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplifaii);
export default __webpack_public_path__ + "static/media/simplifaii.035628ea83bd34c48029216a2425ced4.svg";
export { ForwardRef as ReactComponent };